import React from "react"
import { Checkbox, Input, Select, Typography } from "antd"
import { RegisterStudentCourse } from "./types"
import { css } from "@emotion/react"
import { AntdFormItem } from "../AntdFormItem/AntdFormItem"
import { FormikErrors, FormikTouched } from "formik/dist/types"
import { Field } from "formik"
import { getCountries } from "../../lib/lists/countries"

const commonCol = {
  labelCol: {
    span: 24 - 10
  },
  wrapperCol: {
    span: 10
  }
}

export const RegisterCourseCustomerFormFields: React.FC<Props> = ({ errors, touched, handleChange, handleBlur, values, setFieldValue, coursePrice }) => {
  if (coursePrice === 0) {
    return null
  }

  return (
    <>
      <Typography.Title level={3}>Fakturační údaje</Typography.Title>

      <AntdFormItem<RegisterStudentCourse> label="Jméno a příjmení" errors={errors} touched={touched} {...commonCol}>
        {values.studentContact?.firstname?.length > 0 && values.studentContact?.lastname?.length > 0
          ? `${values.studentContact.firstname} ${values.studentContact.lastname}`
          : `${values.student.firstname} ${values.student.lastname}`}
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> label="Email" errors={errors} touched={touched} {...commonCol}>
        {!errors.studentContact?.email && !errors.student?.email && values.studentContact?.email?.length > 0
          ? values.studentContact?.email
          : values.studentContact.email}
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> name="invoice.street" label="Ulice" errors={errors} touched={touched} {...commonCol}>
        <Field name="invoice.street">{({ field }) => <Input {...field} onChange={handleChange} onBlur={handleBlur} />}</Field>
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> name="invoice.city" label="Město" errors={errors} touched={touched} {...commonCol}>
        <Field name="invoice.city">{({ field }) => <Input {...field} onChange={handleChange} onBlur={handleBlur} />}</Field>
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> name="invoice.country" label="Země" errors={errors} touched={touched} {...commonCol}>
        <Field name="invoice.name">
          {({ field }) => (
            <Select
              showSearch
              {...field}
              value={values.invoice?.country}
              onChange={(value) => setFieldValue("invoice?.country", value, true)}
              onBlur={handleBlur}>
              {getCountries().map(({ code, name }) => (
                <Select.Option key={code} value={code}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Field>
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> name="invoice.zip" label="PSČ" errors={errors} touched={touched} {...commonCol}>
        <Field name="invoice.zip">{({ field }) => <Input {...field} onChange={handleChange} onBlur={handleBlur} />}</Field>
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> name="invoice.registration_no" label="IČO" errors={errors} touched={touched} {...commonCol}>
        <Field name="invoice.registration_no">{({ field }) => <Input {...field} onChange={handleChange} onBlur={handleBlur} />}</Field>
      </AntdFormItem>

      <AntdFormItem<RegisterStudentCourse> name="invoice.vat_no" label="DIČ" errors={errors} touched={touched} {...commonCol}>
        <Field name="invoice.vat_no">{({ field }) => <Input {...field} onChange={handleChange} onBlur={handleBlur} />}</Field>
      </AntdFormItem>
    </>
  )
}

interface Props {
  values: RegisterStudentCourse
  errors: FormikErrors<RegisterStudentCourse>
  touched: FormikTouched<RegisterStudentCourse>
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  handleBlur: (e: any) => void
  handleChange: (e: any) => void
  coursePrice: number
}
